import { Stack, PageGrid, Box, Grid } from '@eneco/sparky';
import { useContent, useLayoutData, Placeholder } from '@sitecore/common';
import { DynamicPricingTariffsRendering } from '@sitecore/types/DynamicPricingTariffs';

import { GraphView } from '../components/Graph/GraphView';
import { DynamicPricingTariffsProvider } from '../hooks/useDynamicPricingTariffs';

const DynamicPricingTariffs = () => {
  const { params: { anchorId = '', hideElectricityOption = '0', hideGasOption = '0' } = {} } =
    useContent<DynamicPricingTariffsRendering>();
  const { context } = useLayoutData();

  return (
    <PageGrid>
      <PageGrid.Item gridColumn="1/-1">
        <Box id={anchorId} paddingBottom="8">
          <Stack gap="6">
            <Grid columns={{ initial: 1, lg: 2 }} gap="6">
              <Placeholder name="jss-graph-cards" />
            </Grid>
            <DynamicPricingTariffsProvider
              isRestrictedPage={context?.restricted}
              hideElectricityOption={hideElectricityOption === '1'}
              hideGasOption={hideGasOption === '1'}>
              <GraphView />
            </DynamicPricingTariffsProvider>
          </Stack>
        </Box>
      </PageGrid.Item>
    </PageGrid>
  );
};

export default DynamicPricingTariffs;
